import {Dialog, DialogContent, DialogContentText, DialogTitle, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const InfoDialog = ({open, handleClose, fullScreen, title, content}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='md'
      fullWidth
      fullScreen={fullScreen}
    >
      <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>

      <IconButton
        onClick={handleClose}
        sx={{position: 'absolute', right: 12, top: 9}}
      >
        <CloseIcon/>
      </IconButton>

      <DialogContent sx={{pt: 0}}>
        <DialogContentText>
          {content}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default InfoDialog;